import { useSelector } from 'react-redux';
import * as ContactReportService from 'services/users/report';

export const useContactReportService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchReports = async (options = {}) => {
    const { error, payload } = await ContactReportService.read({
      ...options,
      token
    });
    if (error) {
      return { reports: [] };
    }

    return { reports: payload.data };
  };

  const fetchComparativeReport = async (options = {}) => {
    const { error, payload } = await ContactReportService.readComparativeReport({
      ...options,
      token
    });
    if (error) {
      return { report: [] };
    }

    return { report: payload };
  };

  const fetchDistributionReports = async (options = {}) => {
    const { error, payload } = await ContactReportService.readDistributionReports({
      ...options,
      token
    });
    if (error) {
      return { distribution: [] };
    }

    return { distribution: payload };
  };

  const fetchPerformanceReport = async (options = {}) => {
    const { error, payload } = await ContactReportService.readPerformanceReport({
      ...options,
      token
    });
    if (error) {
      return { report: {} };
    }

    return { report: payload };
  };

  return {
    fetchComparativeReport,
    fetchDistributionReports,
    fetchPerformanceReport,
    fetchReports
  };
};
